import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "menu-text" }

import { useI18n } from 'vue-i18n';
import { MenuItem } from '@/models/layout.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'mainMenuItem',
  props: {
    route: {},
    icon: {},
    label: {},
    isActive: { type: Boolean },
    separator: { type: Boolean },
    visible: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.route,
    class: _normalizeClass(["menu-item", { 'active-menu-item': _ctx.isActive }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "icon-container img-white",
          src: _ctx.icon,
          alt: _unref(t)(_ctx.label)
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(_ctx.label)), 1)
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})